var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"infopane",attrs:{"title":(_vm.win_w + "px/" + _vm.win_h + "px")}},[_c('b',[_vm._v(_vm._s(_vm._f("round")(_vm.ratio,2)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }